import { CONTRACT_ACTION_BASES_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { IContractActionRequestBody, IContractActionResponse } from "./models";

const defaultProvide = () => getToken();

export const doAction = (
  body: IContractActionRequestBody
): Promise<IContractActionResponse> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_ACTION_BASES_URL}`,
    "POST",
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};
